import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="emka-logo"
      className={`flex items-baseline gap-2 select-none ${className}`}
      aria-label="EMKA GROUP — Home"
    >
      <span
        className="font-display font-extrabold tracking-wider text-white"
        style={{ fontSize: "1.6rem", letterSpacing: "0.06em" }}
      >
        EMKA
      </span>
      <span
        className="font-display font-medium uppercase"
        style={{
          fontSize: "0.85rem",
          letterSpacing: "0.32em",
          color: "var(--emka-gold)",
        }}
      >
        Group
      </span>
    </Link>
  );
};

export default Logo;
